import { cn } from '../../../utils/common-utils.ts';

interface BluebookCalculatorIconProps {
  className?: string;
}

const keyRects = [
  { x: 7.1, y: 11.2 },
  { x: 10.95, y: 11.2 },
  { x: 14.8, y: 11.2 },
  { x: 7.1, y: 14.75 },
  { x: 10.95, y: 14.75 },
  { x: 14.8, y: 14.75 },
  { x: 7.1, y: 18.3 },
  { x: 10.95, y: 18.3 },
  { x: 14.8, y: 18.3 },
];

const BluebookCalculatorIcon = ({
  className,
}: BluebookCalculatorIconProps) => (
  <svg
    aria-hidden="true"
    className={cn('shrink-0', className)}
    fill="none"
    viewBox="0 0 24 24"
  >
    <rect
      x="4.25"
      y="3.25"
      width="15.5"
      height="17.5"
      rx="1.85"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <rect x="7.1" y="6.35" width="9.8" height="2.25" rx="0.65" fill="currentColor" />
    {keyRects.map(({ x, y }) => (
      <rect
        key={`${x}-${y}`}
        x={x}
        y={y}
        width="1.75"
        height="1.75"
        rx="0.35"
        fill="currentColor"
      />
    ))}
  </svg>
);

export default BluebookCalculatorIcon;
